module.exports = __webpack_public_path__ + "static/media/icon-print.7f703b58.svg";